import React, { Component } from 'react';
import Page from '../containers/page';


import {
  Container,
  Row,
  Col,
} from 'reactstrap';

import AccountNav from '../components/accountNav';
import image from '../assets/images/account-cover.png';
import imageMobile from '../assets/images/account-cover.png';
import Article from '../components/article';
import * as FileSaver from 'file-saver';
import {API_ENDPOINT, CDN_URL} from '../constants';
import Exceljs from "exceljs";
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts;

class WishlistPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props.initialData,
      controlPanel: true,
    };
  }


  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }

  submit = (data) => {
    fetch(API_ENDPOINT + '/account/update', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.error) {
          this.setState({ error: result.error });
        } else {
          this.props.verifyUser();
        }
      });
  };
  removeAll = () => {
    fetch(API_ENDPOINT + '/wishlist/remove-all', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json',
      },
    })
        .then((res) => res.json())
        .then((result) => {
          if (result.error) {
            this.setState({ error: result.error });
          } else {
            this.props.verifyUser();
          }
        });
}

    getBase64ImageFromUrl = async (imageUrl, { maxW = 300, maxH = 300, quality = 0.82 } = {}) => {
        const res = await fetch(imageUrl, { cache: "no-store" });
        if (!res.ok) throw new Error(`Failed to fetch image: HTTP ${res.status} ${res.statusText}`);

        const contentType = (res.headers.get("content-type") || "").toLowerCase();
        const mime = contentType.split(";")[0];

        const allowedMimes = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/avif"];
        if (!allowedMimes.includes(mime)) {
            throw new Error(`Invalid content-type: ${contentType || "unknown"}`);
        }

        const blob = await res.blob();
        const bitmap = await createImageBitmap(blob);

        let w = bitmap.width;
        let h = bitmap.height;
        const scale = Math.min(maxW / w, maxH / h, 1);
        w = Math.max(1, Math.round(w * scale));
        h = Math.max(1, Math.round(h * scale));

        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;

        const ctx = canvas.getContext("2d", { alpha: false });
        ctx.drawImage(bitmap, 0, 0, w, h);
        const outMime = "image/jpeg";
        const dataUrl = canvas.toDataURL(outMime, quality);
        return dataUrl.replace(/\s/g, "");
    };

    exportToPdf = async () => {
        const { wishlist = [], lang, uData = {} } = this.props;
        const isFobClient = uData.isFobClient || false;

        const body = [
            isFobClient
                ? [
                    { text: 'Photo', bold: true },
                    { text: 'SKU', bold: true },
                    { text: 'Product Name', bold: true },
                    { text: 'Color', bold: true },
                    { text: 'Loading', bold: true },
                    { text: 'CBM', bold: true },
                    { text: 'MOQ', bold: true },
                    { text: 'Supplier Code', bold: true },
                    { text: 'Price FOB', bold: true },
                ]
                : [
                    { text: 'Photo', bold: true },
                    { text: 'SKU', bold: true },
                    { text: 'Product Name', bold: true },
                    { text: 'Color', bold: true },
                    { text: 'GTIN', bold: true },
                    { text: 'Price', bold: true },
                    { text: 'Stock', bold: true },
                ],
        ];

        const safeText = (val) => ({ text: val != null ? String(val) : '' });

        for (const item of wishlist) {
            const {
                images,
                sku,
                name,
                attributes,
                eanCode,
                price,
                loading,
                inbound_cbmpcs,
                moq,
                supplier_code,
                inStock,
                productFamily,
            } = item;

            let imageCell = { text: '' }; // Default to empty text if no image

            if (images?.[0]?.bildbankId) {
                console.log('USLO', images[0])
                const url = `${CDN_URL}/bb-derivatives/derivatives/${images[0].bildbankId}/thumb_w400.webp`
                console.log(url)
                try {
                    const imageDataUrl = await this.getBase64ImageFromUrl(url);
                    if (imageDataUrl) {
                        imageCell = { image: imageDataUrl, width: 100 };
                    }
                } catch (err) {
                    // Log the error but allow the loop to continue
                    console.warn(`Skipping image for SKU ${sku}:`, err.message);
                }
            }

            const fullName = `${productFamily || ''} ${name?.[lang] || ''}`.trim();

            if (isFobClient) {
                body.push([
                    imageCell,
                    safeText(sku),
                    safeText(fullName),
                    safeText(attributes?.main_colour_1),
                    safeText(loading),
                    safeText(inbound_cbmpcs),
                    safeText(moq),
                    safeText(supplier_code),
                    safeText(`${price?.value ?? ''} ${price?.currency ?? ''}`),
                ]);
            } else {
                body.push([
                    imageCell,
                    safeText(sku),
                    safeText(fullName),
                    safeText(attributes?.main_colour_1),
                    safeText(eanCode),
                    safeText(`${price?.value ?? ''} ${price?.currency ?? ''}`),
                    safeText(inStock),
                ]);
            }
        }

        const docDefinition = {
            content: [
                { text: 'Wishlist Export', style: 'header', margin: [0, 0, 0, 10] },
                {
                    table: {
                        headerRows: 1, // Ensures headers repeat on new pages if table is long
                        widths: isFobClient
                            ? [100, '*', '*', '*', '*', '*', '*', '*', '*']
                            : [100, '*', '*', '*', '*', '*', '*'],
                        body,
                    },
                },
            ],
            styles: {
                header: {
                    fontSize: 12,
                    bold: true,
                },
            },
            pageOrientation: 'landscape',
        };

        pdfMake.createPdf(docDefinition).download('wishlist.pdf');
    };


  exportToExcel = async () => {
    const workbook = new Exceljs.Workbook();
    const worksheet = workbook.addWorksheet('Wishlist');
    const { uData = {}, wishlist = [], lang } = this.props;
    const isFobClient = uData.isFobClient || false;

    // Header definition
    worksheet.columns = isFobClient
        ? [
          { header: 'Photo', key: 'photo', width: 15 },
          { header: 'SKU', key: 'sku', width: 20 },
          { header: 'Product name', key: 'name', width: 30 },
          { header: 'Color', key: 'color', width: 15 },
          { header: 'Loading', key: 'loading', width: 15 },
          { header: 'CBM', key: 'cbm', width: 15 },
          { header: 'MOQ', key: 'moq', width: 15 },
          { header: 'Supplier code', key: 'supplier_code', width: 15 },
          { header: 'Price FOB', key: 'price_fob', width: 15 },
        ]
        : [
          { header: 'Photo', key: 'photo', width: 15 },
          { header: 'SKU', key: 'sku', width: 20 },
          { header: 'Product name', key: 'name', width: 30 },
          { header: 'Color', key: 'color', width: 15 },
          { header: 'GTIN', key: 'gtin', width: 20 },
          { header: 'Price', key: 'price', width: 15 },
          { header: 'Stock', key: 'inStock', width: 15 },
        ];

    for (let i = 0; i < wishlist.length; i++) {
      const item = wishlist[i];
      const {
        images,
        sku,
        name,
        attributes,
        eanCode,
        price,
        loading,
        inbound_cbmpcs,
        moq,
        supplier_code,
        inStock,
        productFamily
      } = item;

      const rowIndex = i + 2;
      const fullName = `${productFamily} ${name?.[lang]}`
      // Add row
      worksheet.addRow(
          isFobClient
              ? {
                sku,
                name: fullName || '',
                color: attributes?.main_colour_1 || '',
                loading: loading || '',
                cbm: inbound_cbmpcs || '',
                moq: moq || '',
                supplier_code: supplier_code ?? '',
                price_fob: `${price?.value ?? ''} ${price?.currency ?? ''}`,
              }
              : {
                sku,
                name: fullName || '',
                color: attributes?.main_colour_1 || '',
                gtin: eanCode || '',
                price: `${price?.value ?? ''} ${price?.currency ?? ''}`,
                inStock: inStock || '',
              }
      );

      // Add image
      if (images?.[0]?.bildbankId) {
        try {
          const imageUrl =  `${CDN_URL}/bb-derivatives/derivatives/${images[0].bildbankId}/thumb_w400.webp`

            const response = await fetch(imageUrl);
          const buffer = await response.arrayBuffer();

          const blob = new Blob([buffer]);
          const imageBitmap = await createImageBitmap(blob);

          const maxWidth = 100;
          const maxHeight = 100;
          let width = imageBitmap.width;
          let height = imageBitmap.height;

          // Proporcionalno skaliranje
          if (width > maxWidth || height > maxHeight) {
            const ratio = Math.min(maxWidth / width, maxHeight / height);
            width = Math.round(width * ratio);
            height = Math.round(height * ratio);
          }

          const imageId = workbook.addImage({
            buffer,
            extension: 'jpg',
          });

          worksheet.addImage(imageId, {
            tl: { col: 0, row: rowIndex - 1 },
            ext: { width, height },
          });

          worksheet.getRow(rowIndex).height = height * 0.75;
        } catch (err) {
          console.error('Image load error:', err);
        }
      }
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const file = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    FileSaver.saveAs(file, 'wishlist.xlsx');
  };



  render() {
    return (
        <div className="account-page">
          <section className="test">
            <img
                src={
                  typeof window !== 'undefined' && window.innerWidth < 768
                      ? imageMobile
                      : image
                }
            />
            <div className="test-content">
              <h1>{'MINA SIDOR'.translate(this.props.lang)}</h1>
            </div>
          </section>

        <Container>
          <Row>
            <Col lg="4">
              <AccountNav {...this.props} />
            </Col>
            <Col lg="8">
              <div className="account-container">
                <div className="wrapper">
                  <h5>{'MINA FAVORITER'.translate(this.props.lang)}</h5>
                  <div>
                    <button className='button -remove-all mr-2' onClick={(e) => this.removeAll()}>{'TA BORT ALLA'.translate(this.props.lang)}</button>
                    <button className='button mr-2' onClick={(e) => this.exportToPdf()}>EXPORT - PDF</button>
                    <button className='button' onClick={(e) => this.exportToExcel()}>EXPORT - XLSX</button>
                  </div>

                </div>


                <Row>
                  {this.props.wishlist.map((item, idx) => {
                    return (
                        <Col lg="4" key={idx}>
                        <Article
                          wishlistDict={this.props.wishlistDict}
                          addToWishlist={this.props.addToWishlist}
                          pathname={this.props[0].location.pathname}
                          uData={this.props.uData}
                          lang={this.props.lang}
                          {...item}
                        />
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Page(WishlistPage);
